import { UpwardForecastExceptionManagerContext } from 'components/specific/upward-forecast/data-manager/upward-forecast-exception-context'
import { useApiGetForecastByCountryCode } from 'core/api/upward-forecast/useApiGetForecastByCountryCode'
import { useApiPutForecastActivateButton } from 'core/api/upward-forecast/useApiPutForecastActivateButton'
import { memo, useContext } from 'react'
import { useTranslation } from 'react-i18next'

interface IActivateButtonProps {
  isDisabled: boolean
  country: string
}

const ActivateButton = ({ isDisabled, country }: IActivateButtonProps) => {
  const { t } = useTranslation()
  const { clearException } = useContext(UpwardForecastExceptionManagerContext)
  const { data: dataForecastByCountryCode } = useApiGetForecastByCountryCode({ countryCode: country })
  const { mutate } = useApiPutForecastActivateButton()
  const upwardForecastData = dataForecastByCountryCode
  const isActivated = upwardForecastData ? upwardForecastData.activated : false
  const isAuthorized = upwardForecastData ? upwardForecastData.authorized : false

  const handleOnClick = () => {
    clearException()
    mutate({
      isActivated,
      countryCode: country
    })
  }

  return (
    <button
      type="button"
      id={`upward-forecast-${upwardForecastData?.activated ? 'activated' : 'deactivated'}`}
      className="vtmn-btn vtmn-btn_variant--secondary vtmn-btn_size--small"
      onClick={isDisabled || !isAuthorized ? null : handleOnClick}
      title={!isAuthorized && country ? t('upward-forecast.disabled-activation') : null}
      disabled={isDisabled || !isAuthorized}
    >
      {upwardForecastData?.activated ? t('deactivate') : t('activate')}
    </button>
  )
}

export default memo(ActivateButton)
